import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);

// ─── DISATTIVA QUALUNQUE SERVICE WORKER GIÀ INSTALLATO ─────────────────────
// RadaR non usa (e non deve usare) funzionalità offline/PWA — se in passato
// un Service Worker è stato registrato (es. impostazione di default di
// Create React App), resta installato nel browser per sempre finché non
// viene esplicitamente disattivato, anche se il codice che lo registrava è
// stato rimosso. Un Service Worker attivo può continuare a servire file
// vecchi dalla sua cache interna, indipendentemente da qualunque cache del
// server o deploy fresco — è probabilmente la causa reale per cui serviva
// un hard refresh (Ctrl+Shift+R) invece di un semplice refresh dopo ogni
// aggiornamento.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(registration => {
        registration.unregister();
      });
    });
    // Svuota anche le cache interne che il Service Worker potrebbe aver
    // popolato in passato, per non lasciare file vecchi da nessuna parte.
    if (window.caches) {
      caches.keys().then(names => {
        names.forEach(name => caches.delete(name));
      });
    }
  });
}
